import React from "react";
import css from "./home.module.css";
import { contact } from "../../../data/contact";
import { FiArrowDownRight, FiArrowRight, FiMail } from "react-icons/fi";
import profilePhoto from "../../../assets/avatar1-professional.webp";

const techStack = [
  "React",
  "Next.js",
  "Node.js",
  "TypeScript",
  "Flutter",
  "MongoDB",
];

const Home = () => {
  return (
    <div className={css.home} id="home">
      <div className={css.content}>
        <div className={css.intro}>
          <p className={css.eyebrow}>
            <span className={css.eyebrowDot} />
            Open to full-stack · mobile · AI roles
          </p>

          <h1 className={css.headline}>
            <span className={css.headlineLead}>I ship full-stack products.</span>
            <span className={css.headlineSupport}>
              Web, mobile, and AI features built to
              <strong> solve real business problems.</strong>
            </span>
          </h1>

          <p className={css.subheadline}>
            I’m Abdellah Khedid, a product-minded developer based in Italy. I
            take features from interface and API design through data,
            deployment, and AI integration helping teams move from idea to
            working software with fewer handoffs.
          </p>

          <div className={css.ctaGroup}>
            <a href="#portfolio" className={css.btnPrimary}>
              <span>See how I build</span>
              <FiArrowDownRight />
            </a>
            <a href="#resume" className={css.btnSecondary}>
              <span>Review experience</span>
              <FiArrowRight />
            </a>
          </div>

          <div className={css.stack} aria-label="Primary technologies">
            <span className={css.stackLabel}>Core stack</span>
            <div className={css.stackList}>
              {techStack.map((tech) => (
                <span key={tech}>{tech}</span>
              ))}
            </div>
          </div>
        </div>

        <aside className={css.profile} aria-label="Developer profile">
          <div className={css.photoShell}>
            <div className={css.photoFrame}>
              <img
                src={profilePhoto}
                alt="Abdellah Khedid, full-stack developer"
                className={css.avatar}
              />
            </div>
            <span className={css.availability}>
              <span className={css.statusDot} /> Available
            </span>
          </div>

          <div className={css.identity}>
            <p>Abdellah Khedid</p>
            <span>Full-stack developer</span>
          </div>

          <dl className={css.profileMeta}>
            <div>
              <dt>Based in</dt>
              <dd>Italy</dd>
            </div>
            <div>
              <dt>Open to</dt>
              <dd>Full-time · Contract · Remote</dd>
            </div>
          </dl>

          <a className={css.emailLink} href={`mailto:${contact.email}`}>
            <FiMail />
            {contact.email}
          </a>
        </aside>
      </div>
    </div>
  );
};

export default Home;
